import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Webinar = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.25 6.5C5.25 4.98122 6.48122 3.75 8 3.75C9.51878 3.75 10.75 4.98122 10.75 6.5V11.5C10.75 11.9142 10.4142 12.25 10 12.25V12C10 11.4477 9.55229 11 9 11H7C6.44772 11 6 11.4477 6 12V14C6 14.5523 6.44772 15 7 15H9C9.55229 15 10 14.5523 10 14V13.75C11.2426 13.75 12.25 12.7426 12.25 11.5V10.75H12.5C13.7426 10.75 14.75 9.74264 14.75 8.5C14.75 7.25736 13.7426 6.25 12.5 6.25H12.2428C12.1134 4.01916 10.2633 2.25 8 2.25C5.73671 2.25 3.88664 4.01916 3.75723 6.25H3.5C2.25736 6.25 1.25 7.25736 1.25 8.5C1.25 9.74264 2.25736 10.75 3.5 10.75H5.25L5.25 6.5ZM12.5 9.25C12.9142 9.25 13.25 8.91421 13.25 8.5C13.25 8.08579 12.9142 7.75 12.5 7.75H12.25V9.25H12.5ZM3.5 7.75C3.08579 7.75 2.75 8.08579 2.75 8.5C2.75 8.91421 3.08579 9.25 3.5 9.25H3.75L3.75 7.75H3.5ZM7.5 12.5V13.5H8.5V12.5H7.5Z"
      fill="currentColor"
    />
  </Icon>
));

export default Webinar;
